import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  FunctionField,
  DateField,
  Pagination,
  useShowController,
  useNotify
} from 'react-admin';
import { Box, Typography, Chip, Tooltip, IconButton } from '@mui/material';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import LaptopIcon from '@mui/icons-material/Laptop';
import TabletIcon from '@mui/icons-material/Tablet';
import DevicesIcon from '@mui/icons-material/Devices';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import EmptyState from '../EmptyState';
import useStyles from './styles';

const DeviceTypeChip = ({ record }) => {
  const classes = useStyles();
  const os = record.baseOs?.toLowerCase() || '';
  let icon = <DevicesIcon fontSize="small" />;
  if (os.includes('android')) {
    icon = <PhoneAndroidIcon fontSize="small" />;
  } else if (os.includes('ios') || os.includes('iphone') || os.includes('apple')) {
    icon = <PhoneIphoneIcon fontSize="small" />;
  } else if (os.includes('windows') || os.includes('mac') || os.includes('osx')) {
    icon = <LaptopIcon fontSize="small" />;
  } else if (os.includes('ipad') || os.includes('tablet')) {
    icon = <TabletIcon fontSize="small" />;
  }
  return (
    <Chip
      icon={icon}
      label={record.baseOs || 'Unknown'}
      size="small"
      className={classes.deviceChip}
    />
  );
};

const DeviceTokenField = ({ token }) => {
  const notify = useNotify();
  const display = token ? `${token.slice(0, 10)}...${token.slice(-10)}` : '';
  const handleCopy = () => {
    navigator.clipboard.writeText(token).then(() => {
      notify('Device token copied to clipboard', { type: 'info' });
    });
  };
  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={token}>
        <Typography variant="body2" style={{ wordBreak: 'break-all' }}>
          {display}
        </Typography>
      </Tooltip>
      <IconButton size="small" onClick={handleCopy}>
        <FileCopyIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

const DevicesTab = props => {
  const { record, basePath } = useShowController(props);
  const classes = useStyles();
  if (!record) return null;

  return (
    <Box>
      <Typography variant="h6" className={classes.sectionTitle}>
        Хэрэглэгчийн төхөөрөмжүүд
      </Typography>
      <List
        component="div"
        resource="userDevices"
        basePath={basePath}
        filter={{ userId: record.id }}
        sort={{ field: 'updatedAt', order: 'DESC' }}
        bulkActionButtons={false}
        perPage={25}
        pagination={<Pagination />}
        exporter={false}
        actions={false}
        empty={<EmptyState message="No devices registered for this user" />}
      >
        <Datagrid className={classes.deviceTable}>
          <TextField source="macAddress" label="MAC Address" />
          <FunctionField label="OS" render={record => <DeviceTypeChip record={record} />} />
          <TextField source="apiLevel" label="API Level" />
          <TextField source="deviceId" label="Device ID" />
          <FunctionField label="Device Token" render={record => <DeviceTokenField token={record.deviceToken} />} />
          <TextField source="appVersion" label="App Version" />
          <DateField source="createdAt" label="Created At" showTime />
          <DateField source="updatedAt" label="Updated At" showTime />
        </Datagrid>
      </List>
    </Box>
  );
};

export default DevicesTab; 